import { useId } from 'react';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const selectClass =
  'block w-full rounded-xl border border-line bg-field px-3 py-2.5 text-ink focus:border-ink focus:bg-card focus:outline-none focus:ring-2 focus:ring-ink/10';

export interface BirthMonth {
  month: string;
  year: string;
}

/** `{ month: '3', year: '2008' }` → `'2008-03'`, or `null` while incomplete. */
export function toBirthMonth({ month, year }: BirthMonth): string | null {
  return month && year ? `${year}-${month.padStart(2, '0')}` : null;
}

/** Month and year of birth: only these are collected (PRD age gate). */
export function BirthMonthField({
  value,
  onChange,
}: {
  value: BirthMonth;
  onChange: (next: BirthMonth) => void;
}) {
  const id = useId();
  const thisYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => String(thisYear - i));

  return (
    <fieldset className="space-y-1.5" aria-describedby={`${id}-hint`}>
      <legend className="text-sm font-semibold text-ink">Date of birth</legend>
      <div className="grid grid-cols-2 gap-3">
        <label className="sr-only" htmlFor={`${id}-month`}>
          Month
        </label>
        <select
          id={`${id}-month`}
          required
          autoComplete="bday-month"
          value={value.month}
          onChange={(event) => onChange({ ...value, month: event.target.value })}
          className={selectClass}
        >
          <option value="">Month</option>
          {MONTHS.map((name, index) => (
            <option key={name} value={String(index + 1)}>
              {name}
            </option>
          ))}
        </select>
        <label className="sr-only" htmlFor={`${id}-year`}>
          Year
        </label>
        <select
          id={`${id}-year`}
          required
          autoComplete="bday-year"
          value={value.year}
          onChange={(event) => onChange({ ...value, year: event.target.value })}
          className={selectClass}
        >
          <option value="">Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <p id={`${id}-hint`} className="text-xs text-muted">
        You need to be 13 or older to have an account. We only keep the month and year.
      </p>
    </fieldset>
  );
}
